import "./ReactionAnimation.css";

import clsx from "clsx";
import { FC, useEffect, useState } from "react";

import { useAppSelector } from "store";
import { classUserSelectors } from "store/selectors";
import { REACTION_TO_FILL_COLOR, REACTION_TO_ICON } from "utils/reactions";

type ReactionAnimationProps = {
  classUserId: string;
};

const ReactionAnimation: FC<ReactionAnimationProps> = ({ classUserId }) => {
  const classUser = useAppSelector((state) => classUserSelectors.selectById(state, classUserId));
  const [currentReaction, setCurrentReaction] = useState(classUser?.reaction);
  const [isReactionAnimationVisible, setIsReactionAnimationVisible] = useState(false);

  useEffect(() => {
    if (classUser?.reaction) {
      setIsReactionAnimationVisible(false);

      // This timeout of 0 is needed so that the previous animation is cleared first
      const animationTimeout = setTimeout(() => {
        setCurrentReaction(classUser.reaction);
        setIsReactionAnimationVisible(true);
      }, 0);
      return () => clearTimeout(animationTimeout);
    }
    setCurrentReaction(null);
    setIsReactionAnimationVisible(false);
  }, [classUser?.reaction]);

  if (!classUser) return null;

  const ReactionIcon = currentReaction && REACTION_TO_ICON[currentReaction];

  return (
    <div className="absolute bottom-0 left-0 right-0 top-0 !size-auto overflow-hidden rounded-[inherit]">
      {isReactionAnimationVisible && currentReaction && (
        <div className={clsx("reaction-animation", currentReaction)}>
          <div className="circle-fill">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
              <circle cx="50%" cy="50%" fill={REACTION_TO_FILL_COLOR[currentReaction]} r="50%" />
            </svg>
          </div>
          {currentReaction && ReactionIcon && (
            <div className="reaction-icon">
              <ReactionIcon />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export { ReactionAnimation };
